@if (activeFiltersExtended$ | async; as filters) {
  @for (filter of filters; track filter.name + filter.text) {
    <span class="search-tag">
      @if (filter.tag == 'Text') {
        <span class="search-tag-prepend">
          {{ filter.name }}
        </span>
      } @else {
        <span class="search-tag-prepend">
          <i class="mdi mdi-filter"></i>
        </span>
      }
      @if (filter.tag == 'BuiltIn' ||
        'SmartAction' ||
        'Permanent') {
        <span class="search-tag-value">
          {{ filter.text }}
        </span>
      }
      @if (filter.tag == 'Custom') {

        @let domains = filter.domains | formattedDomain;
        @if (!!domains) {
          <span class="search-tag-value">
            @for (domain of domains; track domain.field + domain.fieldLabel + domain.fieldLabel) {
              @if (filter.domains.length != 1 && domains.indexOf(domain) != 0) {
                <span>
                  <i translate> GLOBAL_MSG_OR</i>
                </span>
              }
              @switch (domain.operator.numberOfValues) {
                @case (2) {
                  <span>
                    {{ domain.fieldLabel }}
                    {{ domain.operator.label }}
                    @if (isValidDate(domain.text)) {
                      {{ domain.text | date : "dd-MM-yyyy" }}
                    } @else {
                      {{ domain.text }}
                    }
                    <span translate>GLOBAL_MSG_AND</span>
                    @if (isValidDate(domain.text2)) {
                      {{ domain.text2 | date : "dd-MM-yyyy" }}
                    } @else {
                      {{ domain.text2 }}
                    }
                  </span>
                }
                @default {
                  {{ domain.fieldLabel }}
                  {{ domain.operator.label }}
                  @if (isValidDate(domain.text)) {
                    {{ domain.text | date : "dd-MM-yyyy" }}
                  } @else {
                    <span [innerHTML]="domain.text | safeHtml"></span>
                  }
                }
              }
            }
          </span>
        }
      }
      @if (filter.tag == 'Text') {
        <span class="search-tag-value">
          @for (domain of filter.domains; track domain.field + domain.fieldLabel + domain.value) {
            @if (filter.domains.length != 1 && filter.domains.indexOf(domain) != 0) {
              <span>
                <i translate>GLOBAL_MSG_OR</i>
              </span>
            }
            {{ domain.value }}
          }
        </span>
      }

      @if (filter.canRemove) {
        <span class="search-tag-append" (click)="removeFilter(filters.indexOf(filter))">
          <i class="mdi mdi-close"></i>
        </span>
      }

    </span>
  }
}
